import Swiper from 'swiper/bundle';

export default class {
  constructor() {
    let that = this;


    if (document.querySelector(".mySwiper") && document.querySelector(".mySwiper2")) {
      var swiper = new Swiper(".mySwiper", {
        loop: false,
        spaceBetween: 10,
        slidesPerView: 7,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      });
      var swiper2 = new Swiper(".mySwiper2", {
        loop: false,
        spaceBetween: 10,
        navigation: {
          nextEl: ".product-header__images-nav.swiper-button-next",
          prevEl: ".product-header__images-nav.swiper-button-prev",
        },
        thumbs: {
          swiper: swiper,
        },
      });
    }

    if (document.querySelector(".mySwiper3") && document.querySelector(".mySwiper4")) {
      var swiper4 = new Swiper(".mySwiper4", {
        loop: false,
        spaceBetween: 0,
        slidesPerView: 1,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      });
      var swiper3 = new Swiper(".mySwiper3", {
        loop: false,
        spaceBetween: 0,
        navigation: {
          nextEl: ".product-slider__slider-nav.swiper-button-next",
          prevEl: ".product-slider__slider-nav.swiper-button-prev",
        },
        thumbs: {
          swiper: swiper4,
        },
      });
    }

    if (document.querySelector(".mySwiper5")) {
      var swiper5 = new Swiper(".mySwiper5", {
        loop: true,
        spaceBetween: 0,
        slidesPerView: 1,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".product-testimonials__slider-nav.swiper-button-next",
          prevEl: ".product-testimonials__slider-nav.swiper-button-prev",
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
        },
      });
      
    }
  }
}
